import { useContext } from 'react';
import { useGetNotifications } from '../hooks/u003/useGetNotificationsHooks';
import { useGetNews } from '../hooks/u003/useGetNewsHooks';
import { useGetAuditionsParticipated } from '../hooks/u003/useGetAuditionsParticipatedHooks';
import { MediaQueryEnum, useMediaQuery } from '../commons/utils';
import { AppFooter } from 'templates/AppFooter';
import { PageContent } from 'templates/PageContent';
import { NotificationArea } from 'organisms/u003/NotificationArea';
import { LinkedList } from 'organisms/u003/LinkedList';
import { TopMenu } from 'organisms/u003/TopMenu';
import { Mobile } from 'organisms/u003/Mobile';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { VolumeDown } from '@mui/icons-material';
import EmojiEmotionsSharpIcon from '@mui/icons-material/EmojiEmotionsSharp';
import { PATHS } from 'commons/paths';
import { AppContext } from 'templates/AppContextProvider';
import { useTranslationWithLang } from 'hooks/useTranslationWithLang';
import LoadingModal from 'organisms/LoadingModal';

//TODO:必要に応じてComponentをCommonに移動
//TODO:コードを整理するなら各Componentを所定フォルダに移動。

export function MyPageTop() {
  // context
  const ctx = useContext(AppContext);
  // hooks
  const [notifications, loadingOnNotifications, errOnNotifications] = useGetNotifications(
    ctx.currentLang
  );
  const [news, loadingOnFetchNews, errOnFetchNews] = useGetNews(ctx.currentLang);
  const [auditions, loading_audition, errOnFetchAudtions] = useGetAuditionsParticipated();
  const isSp = useMediaQuery(MediaQueryEnum.sp);
  const { t: tMypage } = useTranslationWithLang('mypage');
  const { t: tMessage } = useTranslationWithLang('message');
  // モバイル版表示
  if (isSp) {
    return (
      <>
        <PageContent>
          <Mobile
            notifications={notifications}
            loadingOnNotifications={loadingOnNotifications}
            errOnNotifications={errOnNotifications}
            news={news}
            loadingOnFetchNews={loadingOnFetchNews}
            errOnFetchNews={errOnFetchNews}
            auditions={auditions}
            loadingOnFetchAuditions={loading_audition}
            errOnFetchAuditions={errOnFetchAudtions}
            isSp={true}
          />
        </PageContent>
        <AppFooter />
      </>
    );
  }

  // PC版表示
  return (
    <>
      {(loadingOnFetchNews || loadingOnNotifications || loading_audition) && <LoadingModal />}
      <div
        className="max-w-[70%] mx-auto overflow-y-hidden h-screen"
        style={{ background: 'var(--c-background)' }}
      >
        <div role="heading" aria-level={1} aria-live="assertive" className="sr-only">
          {tMypage('TU003_008')}
        </div>
        <div className="min-h-screen mx-auto flex flex-col h-full">
          <TopMenu isSp={false} />
          <main className="h-full flex flex-col pb-28 pt-10 overflow-hidden justify-center mx-auto md:w-full lg:w-3/4">
            <div className="flex justify-center items-center w-full h-1/2 max-h-full p-4">
              <NotificationArea
                title={tMypage('TU003_001')}
                icon={<NotificationsIcon className="text-white" />}
                data={notifications.map((n) => {
                  return {
                    id: n.notice_id,
                    title: n.notice_title,
                    notice: n.notice,
                    published_at: n.start_dtm,
                    file1: n.file1 ?? undefined,
                    file2: n.file2 ?? undefined,
                    file3: n.file3 ?? undefined,
                    file4: n.file4 ?? undefined,
                    file5: n.file5 ?? undefined,
                  };
                })}
                err={errOnNotifications ? tMessage('MU003F0035E') : null}
                loading={loadingOnNotifications}
                expanded={false}
                noItemsMsg={tMessage('MU003F0038E')}
                buttonLabel={tMypage('TU003_002')}
                isSp={isSp}
              />
            </div>
            <div className="flex justify-center items-center w-full h-1/2">
              <div className="flex-1 h-full p-4">
                <LinkedList
                  title={tMypage('TU003_003')}
                  icon={<EmojiEmotionsSharpIcon className="text-white" />}
                  items={auditions.auditions.map((v) => {
                    return {
                      key: `${v.id}`,
                      title: v.title,
                      link: `${PATHS.AUDITION_INFO}/${v.id}`,
                    };
                  })}
                  err={errOnFetchAudtions ? tMessage('MU003F0035E') : null}
                  loading={loading_audition}
                  noItemMsg={tMessage('MU003F0037E')}
                />
              </div>
              <div className="flex-1 h-full p-4">
                <LinkedList
                  title={tMypage('TU003_004')}
                  icon={<VolumeDown className="text-white" />}
                  items={news.map((v) => {
                    return {
                      key: `${v.news_id}`,
                      title: v.news_title,
                      link: '#',
                      details: {
                        id: v.news_id,
                        published_at: v.start_dtm,
                        notice: v.news,
                        file1: v.file1,
                        file2: v.file2,
                        file3: v.file3,
                        file4: v.file4,
                        file5: v.file5,
                      },
                    };
                  })}
                  err={errOnFetchNews ? tMessage('MU003F0035E') : null}
                  loading={loadingOnFetchNews}
                  noItemMsg={tMessage('MU003F0036E')}
                />
              </div>
            </div>
          </main>
        </div>
        <AppFooter />
      </div>
    </>
  );
}
